import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBL1WVCqR8T7cVm2S_lLDcYMcQSZjHpKtg",
  authDomain: "active-g-41cdc.firebaseapp.com",
  projectId: "active-g-41cdc",
  storageBucket: "active-g-41cdc.firebasestorage.app",
  messagingSenderId: "868280684180",
  appId: "1:868280684180:web:0e6191100908625440ae81",
  measurementId: "G-RPX5R0MBCH",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const storage = getStorage(app);

export { db, auth, provider, storage };
